import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initApiEndpoint } from './utils/apiEndpoint';
import TicketingPreview from './pages/ticketing/TicketingPreview';
import { PREVIEW_PATH } from './utils/ticketingPreview';

const root = ReactDOM.createRoot(document.getElementById('root'));
const render = () =>
  root.render(
    <React.StrictMode>
      {window.location.pathname.startsWith(PREVIEW_PATH) ? <TicketingPreview /> : <App />}
    </React.StrictMode>
  );

// Pick home-vs-AWS backend before the first request; render regardless if it
// stalls. No-op (resolves instantly) when REACT_APP_HOME_API_URL is unset.
initApiEndpoint().finally(render);

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
